export const CHANNEL_STATES = {
  LOADING: 'loading',
  READY: 'ready',
  NOT_FOUND: 'not_found',
  UNAVAILABLE: 'unavailable',
  TEMPORARY_ERROR: 'temporary_error',
};

export function getChannelFailure(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.code;

  if (status === 404 || code === 'CHANNEL_NOT_FOUND') {
    return {
      state: CHANNEL_STATES.NOT_FOUND,
      title: 'This chat link is not available',
      message: 'The channel may have been removed, or the link may be incorrect.',
      canRetry: false,
    };
  }

  if (status === 410 || status === 403) {
    return {
      state: CHANNEL_STATES.UNAVAILABLE,
      title: 'This chat is currently unavailable',
      message: 'Please try again later or contact the person who shared this link.',
      canRetry: true,
    };
  }

  if (!error?.response || status >= 500) {
    return {
      state: CHANNEL_STATES.TEMPORARY_ERROR,
      title: "We couldn't load this chat",
      message: 'There may be a temporary connection problem. Please try again.',
      canRetry: true,
    };
  }

  return {
    state: CHANNEL_STATES.UNAVAILABLE,
    title: 'This chat is unavailable',
    message: error?.response?.data?.error || 'This channel cannot be opened right now.',
    canRetry: true,
  };
}
